import React, { FunctionComponent } from 'react';

import config from '../../config';
import { useTranslation } from 'react-i18next';

const DonateBoxMessage: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <section data-qa="donate-box-message">
      <p>{t('donateBoxMessage.copy')}</p>
      <p>
        <a href={`${config.base_url}/events/donation-prompts`}>
          {t('donateBoxMessage.linkLabel')}
        </a>
      </p>
    </section>
  );
};

export default DonateBoxMessage;
